
import { mdiMapMarker, mdiMapMarkerOutline } from "@mdi/js"
import { routeToBusinessSite } from "@/helpers/routing"
export default {
    name: "BusinessLocation",
    components: {
        StadiaMap: () =>
            // load StadiaMap only client-side
            process.client
                ? import("@/components/base/StadiaMap")
                : Promise.resolve({ render: (h) => h("div") }),
    },
    props: {
        business: {
            type: Object,
            default: null,
        },
        rounded: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            selectedSite: null,
            center: null,
            mdiMapMarker,
            mdiMapMarkerOutline,
            mapLoaded: false,
        }
    },
    computed: {
        locationHeadline() {
            return this.business.business_sites?.length > 1
                ? "Unsere Standorte"
                : "Unser Standort"
        },
        logoSrc() {
            return this.$getImage({
                image: this.business.logo,
                preferedSize: "3",
            }).src
        },
        mapMarkers() {
            let markers = []
            const logoSrc = this.logoSrc
            this.business.business_sites?.map((site) => {
                markers.push({
                    lat: site.address.lat,
                    lng: site.address.lng,
                    iconSrc: logoSrc,
                    label: site.name,
                    clickFunction: () =>
                        this.$router.push(routeToBusinessSite(site)),
                })
            })
            return markers
        },
    },
    created() {
        const mainBusinessSite = this.business.business_sites.find(
            (s) => s.is_main
        )
        this.setActiveSite(mainBusinessSite)
    },
    methods: {
        getLocationString(address) {
            return `${address.postal_code} ${address.city}, ${address.street}`
        },
        isActiveSite(site) {
            return this.selectedSite?.id === site.id
        },
        setActiveSite(site) {
            this.selectedSite = site
            this.center = [site.primary_address.lat, site.primary_address.lng]
        },
    },
}
